<template>
  <div>
    <el-progress v-if="socket_key" :percentage="progress"></el-progress>
    <div class="search-wrap">
      <el-button size="mini" @click="pageChange(1)">查询</el-button>
      <el-button size="mini" @click="getOrderExcel()">导出分摊费用（旧方法）</el-button>
      <el-button size="mini" @click="getSalesExcel()">导出物业费用（旧方法）</el-button>

      <el-button size="mini" @click="getAllExcel()">综合账单导出</el-button>
    </div>
    <div>
      <el-descriptions :column="2" border size="mini" :labelStyle="{width: '100px'}" :contentStyle="{width:'41%'}">
        <el-descriptions-item label="项目房产">
          {{mainObj.house_name?mainObj.house_name:'请选择项目房产'}}
        </el-descriptions-item>
        <el-descriptions-item label="抄表月份">
          <el-date-picker
            v-model="mainObj.read_month"
            size="mini"
            type="month"
            format="yyyy-MM"
            value-format="yyyy-MM"
            @change="pageChange(1)"
            placeholder="选择月">
          </el-date-picker>
        </el-descriptions-item>
        <el-descriptions-item label="客户房产">
          <el-autocomplete
            style="min-width: 400px;max-width: 100%"
            size="mini"
            v-model="mainObj.house_name"
            :fetch-suggestions="querySearchAsyncRoom"
            @select="handleSelect"
            placeholder="请输入房产"
            popper-class="autocomplete-room"
            clearable
          ></el-autocomplete>
        </el-descriptions-item>
        <el-descriptions-item label="应收日期">
          <el-date-picker
            v-model="where.should_charge_date"
            size="mini"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            @change="pageChange(1)"
            placeholder="选择日期">
          </el-date-picker>
        </el-descriptions-item>
        <el-descriptions-item label-class-name="descriptions-label-class" label="客户名称">
          <el-autocomplete
            class="w-300"
            size="mini"
            v-model="where.customer_name"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入姓名"
            @select="handleSelect2"
          ></el-autocomplete>
        </el-descriptions-item>

        <el-descriptions-item label="收费项目">
          <el-select size="mini" style="width: 100%" v-model="where.chargeItem_name_id" filterable clearable placeholder="收费项目" class="kuan" @change="pageChange(1)">
            <el-option v-for="item in house_charge_item_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="收费标准">
          <el-select size="mini" style="width: 100%" v-model="where.charging_standard" filterable clearable placeholder="收费标准" class="kuan" @change="pageChange(1)">
            <el-option v-for="item in house_charge_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-descriptions-item>

<!--        <el-descriptions-item label="仪表编号">-->
<!--          <el-input size="mini" placeholder="请输入仪表编号" v-model="where.number" @change="pageChange(1)" clearable></el-input>-->
<!--        </el-descriptions-item>-->
<!--        <el-descriptions-item label="仪表名称">-->
<!--          <el-input size="mini" placeholder="请输入仪表名称" v-model="where.name" clearable @change="pageChange(1)"></el-input>-->
<!--        </el-descriptions-item>-->
<!--        <el-descriptions-item label="仪表类型">-->
<!--          <el-select size="mini" style="width: 100%" v-model="where.meter_type" clearable filterable placeholder="类型" class="kuan" @change="pageChange(1)">-->
<!--            <el-option v-for="item in meter_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>-->
<!--          </el-select>-->
<!--        </el-descriptions-item>-->
        <el-descriptions-item label="能耗类型">
          <el-select size="mini" style="width: 100%" v-model="where.energy" clearable filterable placeholder="类型" class="kuan" @change="pageChange(1)">
            <el-option v-for="item in energy_list" :key="item.val" :label="item.name" :value="item.val"></el-option>
          </el-select>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div>
      <div class="header-tip">
        总计收费： {{formatMoney(order_count_obj.all_money,4)}} 元&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        业主能耗： {{formatMoney(order_count_obj.money_1,4)}} 元&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        分摊能耗 [成本价]： {{formatMoney(order_count_obj.money_3,4)}} 元&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        物业能耗 [销售价]： {{formatMoney(order_count_obj.money_2,4)}} 元&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </div>
    </div>
    <div>
      <el-table v-if="pageData" v-loading="loading" border :data="pageData.list" width="99%" height="50vh">
<!--        <el-table-column type="selection" width="55" fixed></el-table-column>-->
        <!--        <el-table-column prop="id" label="id" width="80"></el-table-column>-->
        <el-table-column prop="h_name_date" label="房产" width="320" align="center" fixed></el-table-column>
        <el-table-column prop="customer_name" label="客户" width="180" align="center"></el-table-column>
        <el-table-column prop="charge_sum" label="周期" width="180" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.startDate}}~{{scope.row.endDate}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="chargePay" label="应收费用" width="100" align="center"></el-table-column>
        <el-table-column prop="charge" label="收费金额" width="100" align="center"></el-table-column>
        <el-table-column prop="should_charge_date" label="应收日期" width="100" align="center"></el-table-column>
        <el-table-column prop="xsc_LastReadDegree" label="上期读数" width="100" align="center"></el-table-column>
        <el-table-column prop="xsc_CurrentReadDegree" label="本期读数" width="100" align="center"></el-table-column>
        <el-table-column prop="charge_item_name" label="收费项目" width="120" align="center"></el-table-column>
        <el-table-column prop="charge_name" label="收费标准" width="200" align="center"></el-table-column>
        <el-table-column prop="xsc_Price" label="单价" width="100" align="center"></el-table-column>
        <el-table-column prop="xsc_Amount" label="数量/用量" width="100" align="center"></el-table-column>
<!--        <el-table-column label="操作 " fixed="right" width="120" align="center">-->
<!--          <template slot-scope="scope">-->
<!--            <el-button v-if="scope.row.is_lock===0" type="danger" size="mini" icon="el-icon-edit" @click="deleteOrderItem(scope.row)">删除</el-button>-->
<!--          </template>-->
<!--        </el-table-column>-->
      </el-table>
    </div>
    <div style="margin-top: 20px;text-align: center;margin-right: 20px;">
      <Page :total="pageData.total*1" :current-page="pageData.page*1" :page-size="pageData.pageSize*1" @on-change="pageChange" show-total />
    </div>

  </div>
</template>

<script>
import {Loading} from "element-ui";
import AppConfig from "../../../../../../config/AppConfig";
import MeterHttp from "../../../common/MeterHttp";

export default {
  name: "MeterOrderUserFlowList",
  inject:['mainObj','where','order_query'],
  data(){
    return{
      apportion_meter_type_list:[{name:"存用量",val:1},{name:"线损",val:2}],
      energy_list:[{name:"业主能耗",val:1},{name:"物业能耗",val:2},{name:"分摊能耗",val:3},],
      energy_obj:{1:"业主能耗",2:"物业能耗",3:"分摊能耗"},
      meter_type_list: [],
      house_charge_list:[],
      house_charge_item_list:[],
      chargeItem_name_ids:null,
      loading: false,
      pageData: {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1
      },
      multipleSelection: [],
      order_count_obj:{
        all_money:0,
        money_1:0,
        money_2:0,
        money_3:0,
        all_count:0,
        count_1:0,
        count_2:0,
        count_3:0,
      },
      progress: 0,
      socket_key:null,
    }
  },
  mounted() {
    this.getMeterTypeList();
    this.mainObj.project_id&&this.getHouseChargeitemNameList();
    this.mainObj.project_id&&this.getHouseChargeList();
    this.pageChange(1)
  },
  methods:{
    getMeterTypeList(){
      const that = this;
      let where={};
      MeterHttp.get("MeterType/getList",{
        project_id:that.mainObj.project_id,
        where:JSON.stringify(where),
        field:"id,name,expenditure_ids,expenditure_name",
        page: 1,
        page_size: 200
      },ret=>{
        if(ret.code){
          that.meter_type_list=ret.data.list;
        }
      })
    },
    pageChange(i){
      this.pageData.page = i
      this.getList()
    },
    getList() {
      const that = this;
      that.loading = true;
      let where = ERP.reJson(this.where);
      where.apportion_meter_types=(where.apportion_meter_types||[]).join(',');
      if(!that.mainObj.read_month){
        that.$message.error('请选择抄表月份');
        return false;
      }
      where.read_month=that.mainObj.read_month;
      where.house_name=that.mainObj.house_name;
      MeterHttp.post("MeterOrderHouse/getHouseList",{
        project_id:that.mainObj.project_id,
        ...where,
        user_type:that.user_type,
        batch_number:that.$route.query.batch_number,
        page: this.pageData.page,
        pageSize: this.pageData.pageSize
      }, res => {
        if (res.code) {
          that.pageData = res.data
        }
        that.loading = false;
        that.multipleSelection = []
      })
      MeterHttp.post("MeterOrderHouse/getDataStatistics",{
        project_id:that.mainObj.project_id,
        ...where,
        batch_number:that.$route.query.batch_number,
        user_type:that.user_type,
      }, res => {
        if (res.code) {
          that.order_count_obj=res.data;
        }
      })
    },
    querySearchAsyncRoom(queryString, cb){
      if(!queryString){
        cb([]);
      }else {
        ERP.postRequest({
          url:"admin/Customer/getHouseList",
          data:{keyWord:queryString}
        },ret=>{
          if(ret.code) {
            cb(ret.data)
          }
        })
      }
    },
    handleSelect(item) {
      // this.where.house_id=item.id||0;
      this.where.house_name=item.value;
      this.pageChange(1);
    },
    querySearchAsync(queryString, cb) {
      const that = this;
      if(!queryString){
        cb([])
        return false
      }
      let from_data={}
      from_data.key_name=queryString;
      ERP.getRequest({url:"admin/Customer/getCustomerList",data:from_data},res=>{
        if (res.code) {
          cb(res.data.map(ret=>{return {
            value:`${ret.name}-【${(ret.house_list.map(re=>re.address).join(','))}】`,//
            id:ret.id,
            data:ret
          }}));
        }
      })
    },
    handleSelect2(item) {
      const that = this;
      // that.where.customer_id=item.data.id||0;
      that.where.customer_name=item.data.name;
      that.pageChange(1);
    },
    reNumber(x){
      return Math.floor(x*10000)/10000
    },
    getOrderExcel(){
      const that = this;
      that.loading = true;
      let where = ERP.reJson(this.where);
      if(!that.mainObj.read_month){
        that.$message.error('请选择抄表月份');
        return false;
      }
      where.read_month=that.mainObj.read_month;
      where.house_name=that.mainObj.house_name;
      where.apportion_meter_types=where.apportion_meter_types.join(',');
      MeterHttp.post("MeterOrderObject/getOrderExcel",{
        project_id:that.mainObj.project_id,
        ...where,
        user_type:that.user_type,
        page: this.pageData.page,
        pageSize: this.pageData.pageSize
      }, res => {
        if (res.code) {
          that.initTaskClient(res.data,()=>{

          })
        }
        that.loading = false;
     })
    },
    getSalesExcel(){
      const that = this;
      that.loading = true;
      let where = ERP.reJson(this.where);
      if(!that.mainObj.read_month){
        that.$message.error('请选择抄表月份');
        return false;
      }
      where.read_month=that.mainObj.read_month;
      where.house_name=that.mainObj.house_name;

      where.apportion_meter_types=where.apportion_meter_types.join(',');
      MeterHttp.post("MeterOrderObject/getSalesExcel",{
        project_id:that.mainObj.project_id,
        ...where,
        user_type:that.user_type,
        page: this.pageData.page,
        pageSize: this.pageData.pageSize
      }, res => {
        if (res.code) {
          that.initTaskClient(res.data,()=>{

          })
        }
        that.loading = false;
     })
    },
    getAllExcel(){
      const that = this;
      that.loading = true;
      let where = ERP.reJson(this.where);
      if(!that.mainObj.read_month){
        that.$message.error('请选择抄表月份');
        return false;
      }
      where.read_month=that.mainObj.read_month;
      where.house_name=that.mainObj.house_name;

      where.apportion_meter_types=where.apportion_meter_types.join(',');
      MeterHttp.post("MeterOrderHouse/getMeterOrderHouseExcel",{
        project_id:that.mainObj.project_id,
        ...where,
        batch_number:that.$route.query.batch_number,
        user_type:that.user_type,
      }, res => {
        if (res.code) {
          window.open(res.data)
          // that.initTaskClient(res.data,()=>{
          //
          // })
        }
        that.loading = false;
      })
    },
    initTaskClient(socket_key,callback){
      const that = this;
      that.socket_key = socket_key;
      MeterHttp.post("TaskClient/getTask",{socket_key: socket_key}, res => {
        if (res.code==1) {
          that.progress = res.data.progress||0;
          if(res.data.progress==100){
            that.$message.success(res.msg || "数据异常");
            that.socket_key = null;
            if(res.data.filepath.indexOf('http')==-1){
              res.data.filepath=AppConfig.erp_server+'/'+res.data.filepath
            }
            window.open(res.data.filepath)
            callback && callback()
          }else{
            setTimeout(() => {
              that.initTaskClient(socket_key,callback)
            }, 2000)
          }

        }else {
          that.socket_key = null;
          that.$message.error(res.msg || "数据异常");
          callback && callback()
        }
      })
    },
    getHouseChargeList(){
      const that = this;
      let where={};
      this.mainObj.project_id&&(where.pindex_id=this.mainObj.project_id);
      this.where.chargeItem_name_id&&(where.chargeItem_name_ids=(this.where.chargeItem_name_id+''));
      ERP.getRequest({
        url:"admin/HouseCharge/getList",
        data:{
          project_id:that.mainObj.project_id,
          where:JSON.stringify(where),
          page: 1,
          page_size: 200
        }
      },ret=>{
        if(ret.code){
          that.house_charge_list=ret.data.list;
        }
      });
    },
    getHouseChargeitemNameList(){
      const that = this;
      let where={};
      this.mainObj.project_id&&(where.pindex_id=this.mainObj.project_id);
      ERP.getRequest({
        url:"admin/HouseChargeitemName/getHouseChargeitemNameList",
        data:{
          project_id:that.mainObj.project_id,
          where:JSON.stringify(where),
          page: 1,
          page_size: 200
        }
      },ret=>{
        if(ret.code){
          that.house_charge_item_list=ret.data;
        }
      });
    },
  },
  computed:{
    all_money(){
      let m_arr=this.pageData.list.map(ret=>ret.charge*1)
      return m_arr.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    },
    dj_money(){
      let m_arr=this.pageData.list.map(ret=>ret.amount/ret.proportion_total*ret.proportion_ext)
      return m_arr.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    },
    user_type(){
      return this.order_query.user_type
    }
  },
  watch:{
    "mainObj.house_name":function (n,o) {
      if(n){
        this.pageChange(1)
      }
    },
    "mainObj.project_id":function (n,o) {
      if(n){
        this.getHouseChargeitemNameList();
      }
    },
    'where2.chargeItem_name_id': {
      handler(val, oldVal) {
        this.where2.charging_standard="";
        this.getHouseChargeList();
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.header-tip{
  margin: 5px 0;
  padding: 5px 10px;
  background-color: #f56c6c;
  color: #FFFFFF;
  border-radius: 4px;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter_order_flow/components/MeterOrderUserFlowList.vue